import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const createChecklist = (taskId, { name }) => {
    return AjaxService({
        method: 'post',
        url: 'checklists',
        data: {
            task_id: taskId,
            name
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchChecklist = checklistId => {
    return AjaxService({
        method: 'get',
        url: `checklists/${checklistId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateChecklist = (checklistId, { name, order }) => {
    return AjaxService({
        method: 'put',
        url: `checklists/${checklistId}`,
        data: {
            name,
            order
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeChecklist = checklistId => {
    return AjaxService({
        method: 'delete',
        url: `checklists/${checklistId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createChecklistItems = (checklistId, items) => {
    return AjaxService({
        method: 'post',
        url: `checklists/${checklistId}`,
        data: items
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateChecklistItem = (checklistId, checklistItemId, { name, order, completed }) => {
    return AjaxService({
        method: 'put',
        url: `checklists/${checklistId}/${checklistItemId}`,
        data: {
            name,
            completed,
            order
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeChecklistItem = (checklistId, checklistItemId) => {
    return AjaxService({
        method: 'delete',
        url: `checklists/${checklistId}/${checklistItemId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
